import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

interface DatenverwaltungFoerderungZuordnungProps extends React.ClassAttributes<any> {
    data: any;
}

export interface DatenverwaltungFoerderungZuordnungState {
    bundle: any;
    foerderung: any;
}

export class DatenverwaltungFoerderungZuordnung extends
    React.Component<DatenverwaltungFoerderungZuordnungProps, DatenverwaltungFoerderungZuordnungState> {

    constructor(props: any) {
        super(props);
        this.state = {
            bundle: null,
            foerderung: null
        };
        this.customFormatter = this.customFormatter.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.init();
    }

    customFormatter(field: string, value: any, data: any, row: any): any {
        return field === 'foerderung' && ((this.state.foerderung || {})[value] || []).length > 1
            ? `${value} (${this.state.foerderung[value].indexOf(data.foerderung_orig || data.foerderung) + 1})`
            : value;
    }

    init(): void {
        const data: any = {};
        const foerderung: any[] = [];

        ((this.props.data || {})[IDs.ENT_FOERDERUNG] || [])
            .sort((a: any, b: any) => a.tid - b.tid)
            .forEach((item: any) => {
                if (typeof data[item.name] === 'undefined') {
                    data[item.name] = [];
                }
                data[item.name].push(item.tid);
            });

        ((this.props.data || {})[IDs.ENT_FOERDERUNG] || []).forEach((item: any, index: number) => {
            const name: string = item.name || null;
            foerderung.push(item);
            foerderung[index].name = data[name].length > 1
                ? `${name} (${data[name].indexOf(item.tid) + 1})`
                : name;
        });
        this.setState({ bundle: { foerderung }, foerderung: data });
    }

    render(): JSX.Element {
        if (!this.state.bundle) {
            return null;
        }

        return (
            <WFormsTableWrapper
                entity={IDs.ENT_FOERDERUNG_ZUORDNUNG}
                module={IDs.MOD_ETOOL_ADMIN}
                actions={['add', 'edit', 'delete']}
                formLayout='flowV2'
                customClass='Custom-ETA'
                bundleFilterFunc={(bundle: any) => bundle.foerderung = this.state.bundle.foerderung || bundle.foerderung}
                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_FOERDERUNG_ZUORDNUNG)}
                customFormatter={this.customFormatter}
                showColumnsHelp
            />
        );
    }
}
